import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

const Page = forwardRef(({ children, title = "", ...rest }, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        backgroundColor: theme => theme.palette.background.dark,
        minHeight: "100%",
        paddingTop: 3,
        paddingBottom: 3,
        ...rest?.sx,
      }}
      {...rest}
    >
      {title && <title>{title}</title>}
      <Container maxWidth={false}>{children}</Container>
    </Box>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
